import { useAppSelector } from '../store/hooks';
import { useGetSimilarPromptsQuery, selectSimilarPrompts } from '../store';

/**
 * Хук для получения похожих промптов из кеша
 * @param promptId - ID промпта для получения похожих
 * @param options - опции запроса
 * @returns объект с данными похожих промптов и состоянием загрузки
 */
export const useSimilarPrompts = (promptId: number, options?: { skip?: boolean }) => {
    const { skip = false } = options || {};

    // Проверяем кеш
    const cachedSimilarPrompts = useAppSelector(state => selectSimilarPrompts(state, promptId));

    // Запрос только если похожих промптов нет в кеше для данного promptId
    const shouldSkip = skip || Boolean(cachedSimilarPrompts?.length);

    const { isFetching, isError, error, isSuccess } = useGetSimilarPromptsQuery({ promptId }, { skip: shouldSkip });

    return {
        data: cachedSimilarPrompts,
        isFetching: isFetching && !cachedSimilarPrompts?.length,
        isError: isError && !cachedSimilarPrompts?.length,
        isSuccess: isSuccess || Boolean(cachedSimilarPrompts?.length),
        error: cachedSimilarPrompts?.length ? null : error,
        isFromCache: Boolean(cachedSimilarPrompts?.length),
    };
};
